import { useMutation, MutationHookOptions, gql } from "@apollo/client"

const UpdateAdditionalPayment = gql`
  mutation UpdateAdditionalPayment(
    $additionalTerminationPaymentId: ID!
    $amount: Float
    $currency: String
    $amountAsPercentage: Float
    $details: String
    $paymentFrequency: String
    $numRecurringPayments: Int
    $payTypeId: ID
    $amountType: String!
  ) {
    updateAdditionalPayment(
      input: {
        additionalTerminationPaymentId: $additionalTerminationPaymentId
        amount: $amount
        currency: $currency
        amountAsPercentage: $amountAsPercentage
        details: $details
        paymentFrequency: $paymentFrequency
        numRecurringPayments: $numRecurringPayments
        payTypeId: $payTypeId
        amountType: $amountType
      }
    ) {
      errors
    }
  }
`

export const useUpdateAdditionalPayment = (options?: MutationHookOptions) => {
  return useMutation(UpdateAdditionalPayment, options)
}
